import { __export } from "./chunk-QK4PKNB3.mjs"; // src/services/chatbot.ts

var chatbot_exports = {};

__export(chatbot_exports, {
  getTranslation: function getTranslation() {
    return _getTranslation;
  }
});

import axios from "axios";
import * as R from "ramda";

var _getTranslation = function _getTranslation(_ref) {
  var msg = _ref.msg,
      _ref$lang = _ref.lang,
      lang = _ref$lang === void 0 ? "en" : _ref$lang;
  return axios.post("/chatbot/translate", {
    input_text: msg,
    target_lang: lang
  }).then(R.prop("data"));
};

export { _getTranslation as getTranslation, chatbot_exports };